'use strict';

const Vue = require('vue');
const axios = require('axios');
const {validateElement} = require('../../../../vue-form/vue-input/libs/validator');
const exclusionResultHandler = require('./exclusion-result-handler');

const MAX_OPTIONS_VISIBLE = 3;

module.exports = (deliveryData) => {
    return {
        namespaced: true,
        state: {
            ...deliveryData
        },
        getters: {
            selectedDeliveryOption: (_, getters) => {
                return getters.selectedDeliveryMethod
                    .options.find((option) => option.selected);
            },
            selectedDeliveryMethod: (state) => {
                const selectedMethod = state.deliveryMethods
                    .find((method) => method.selected);
                return selectedMethod ? selectedMethod : state.deliveryMethods[0];
            },
            postalCodeValue: (state) => {
                return state.postalCodeForm.form.formElements[0].state.value;
            },
            isPickupPersonValid: (state, getters) => {
                const firstNameValid = !validateElement(state.pickupPerson.firstName).length;
                const lastNameValid = !validateElement(state.pickupPerson.lastName).length;

                return getters.selectedDeliveryMethod.id !== 'pickupPoint' ||
                    !state.pickupPerson.isSomeoneElse.state.value ||
                    (firstNameValid && lastNameValid);
            },
            pickupPerson: (state) => {
                return {
                    isSomeoneElse: state.pickupPerson.isSomeoneElse.state.value,
                    firstName: state.pickupPerson.firstName.state.value,
                    lastName: state.pickupPerson.lastName.state.value,
                };
            },
            postnummer: (state) => {
                return {
                    dHLPostNummer: state.postnummer ? state.postnummer.postnummerValue.state.value : ''
                };
            },
            isPostnummerValid: (state, getters) => {
                if (state.postnummer && getters.selectedDeliveryMethod.id === 'pickupPoint') {
                    const postnummerValid = !validateElement(state.postnummer.postnummerValue).length;

                    return postnummerValid;
                }

                return true;
            },
            isPostnummerExist: (state) => {
                const postnummer = state.postnummer;

                return postnummer;
            },
            pickPost: (state) => {
                return {
                    pickPostUserID: state.pickPost ? state.pickPost.pickPostValue.state.value : ''
                };
            },
            isPickPostValid: (state, getters) => {
                if (state.pickPost && getters.selectedDeliveryMethod.id === 'pickupPoint') {
                    const pickPostValid = !validateElement(state.pickPost.pickPostValue).length;

                    return pickPostValid;
                }

                return true;
            },
            isPickPostExist: (state) => {
                const pickPost = state.pickPost;

                return pickPost;
            },
            hasEnabledDeliveryMethods: (state) => state.deliveryMethods.some((x) => x.enabled)
        },
        actions: {
            initializeDeliveryMethods({state, commit}) {
                const homeDeliveryMethod = state.deliveryMethods.find((method) => method.id === 'homeDelivery');
                
                if (homeDeliveryMethod) {
                    commit('selectDeliveryMethod', 'homeDelivery');
                } else if (state.deliveryMethods.length > 0) {
                    const hasSelectedMethod = state.deliveryMethods.some((method) => method.selected);
                    if (!hasSelectedMethod) {
                        commit('selectDeliveryMethod', state.deliveryMethods[0].id);
                    }
                }
            },
            submitPostalCode({state, commit, dispatch}) {
                if (validateElement(state.postalCodeForm.form.formElements[0]).length) {
                    return;
                }
                const postalCode = state.postalCodeForm.form.formElements[0].state.value;
                commit('setLoadingState', true);
                return getLatLong(postalCode)
                    .then((coordinates) => {
                        return axios({
                            method: 'post',
                            url: state.submitPostalCodeURL,
                            data: {postalCode, ...coordinates},
                            headers: {'Content-Type': 'application/json'}
                        });
                    }).then((result) => {
                        commit('setPostalCode', postalCode);
                        exclusionResultHandler(state.exclusionResults, result.data.delivery.exclusionResults, commit);
                        commit('setDeliveryState', result.data.delivery);
                        commit('orderSummary/setOrderSummaryData', result.data.orderSummary, {root: true});
                        dispatch('payments/setGiftCardData', result.data.giftCardData, {root: true});
                        commit('setLoadingState', false);
                    });
            },
            updateSelectedOptionAndMethod({state, commit, dispatch}, selectedOption) {
                const method = state.deliveryMethods.find((method) => method.selected);
                const option = selectedOption || method.options.find((option) => option.selected);
                commit('setLoadingState', true);
                return axios({
                    method: 'post',
                    url: method.updateURL,
                    data: {option, page: 'checkout_v3_page'},
                    headers: {'Content-Type': 'application/json'},
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }
                    exclusionResultHandler(state.exclusionResults, result.data.delivery.exclusionResults, commit);
                    commit('setDeliveryState', result.data.delivery);
                    commit('orderSummary/setOrderSummaryData', result.data.orderSummary, {root: true});
                    dispatch('payments/setGiftCardData', result.data.giftCardData, {root: true});
                    commit('setLoadingState', false);
                });
            },
            getMorePickupPoints({state, commit}) {
                const pickupPointMethod = state.deliveryMethods.find((method) => method.id === 'pickupPoint');
                if (!pickupPointMethod.selected || pickupPointMethod.options.length < 5 || pickupPointMethod.options.length > 19) {
                    return true;
                }

                return axios({
                    method: 'get',
                    url: pickupPointMethod.getMoreURL
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }

                    commit('updatePickupPoints', result.data.pickupPoint);
                    return true;
                });
            },
            updatePickupPerson({getters}) {
                if (getters.selectedDeliveryMethod.id !== 'pickupPoint') {
                    return;
                }
                return axios({
                    method: 'post',
                    url: getters.selectedDeliveryMethod.setPickupPersonURL,
                    data: getters.pickupPerson
                });
            },
            updatePostnummer({getters}) {
                if (getters.selectedDeliveryMethod.id !== 'pickupPoint') {
                    return;
                }
                return axios({
                    method: 'post',
                    url: getters.selectedDeliveryMethod.setPostnummerURL,
                    data: getters.postnummer
                });
            },
            updatePickPost({getters}) {
                if (getters.selectedDeliveryMethod.id !== 'pickupPoint') {
                    return;
                }
                return axios({
                    method: 'post',
                    url: getters.selectedDeliveryMethod.setPickPostURL,
                    data: getters.pickPost
                });
            }
        },
        mutations: {
            selectDeliveryMethod(state, methodId) {
                state.deliveryMethods.forEach((method) => { method.selected = method.id === methodId; });
            },
            selectDeliveryOption(state, optionId) {
                const deliveryOptions = state.deliveryMethods.find((method) => method.selected).options;
                let selectedIndex = 0;
                deliveryOptions.forEach((option, index) => {
                    option.selected = option.id === optionId;
                    if (option.id === optionId) {
                        selectedIndex = index;
                    }
                });

                if (selectedIndex < MAX_OPTIONS_VISIBLE) {
                    return;
                }
                const [selectedOption] = deliveryOptions.splice(selectedIndex, 1);
                deliveryOptions.unshift(selectedOption);
            },
            setPostalCode(state, postalCode) {
                const element = state.postalCodeForm.form.formElements[0];
                element.state.value = postalCode;
                element.validationErrors = validateElement(element);
            },
            addPostalCodeError(state, error) {
                state.postalCodeForm.form.formElements[0].validationErrors = [error];
            },
            removePostalCodeError(state, error) {
                state.postalCodeForm.form.formElements[0].validationErrors =
                    state.postalCodeForm.form.formElements[0].validationErrors.filter((err) => err !== error);
            },
            setDeliveryState(state, deliveryState) {
                const previousEditMode = state.deliverySummary.editMode || deliveryState.exclusionResults.excludedPostal;
                const hadPostalPreApplied = state.deliverySummary.hasPostalCodePreApplied;
                Object.assign(state, deliveryState);
                Object.assign(
                    state.deliverySummary.deliveryAddress,
                    deliveryState.deliverySummary.deliveryAddress
                );
                state.deliverySummary.hasPostalCodePreApplied = hadPostalPreApplied;
                state.deliverySummary.editMode = previousEditMode;
            },
            updatePickupPoints(state, pickupPoint) {
                const pupMethod = state.deliveryMethods.find((method) => method.id === 'pickupPoint');
                Vue.set(pupMethod, 'options', [...pickupPoint.options]);
                pupMethod.flyIn.description = pickupPoint.flyIn.description;
            },
            setPickupPerson(state, pickupPerson) {
                state.pickupPerson = pickupPerson;
            },
            setLoadingState(state, value) {
                state.loadingState = value;
            },
            setEditMode(state, value) {
                state.deliverySummary.editMode = value;
            },
            setPickupPersonFieldValue(state, {fieldId, value}) {
                const field = state.pickupPerson[fieldId];
                if (field) {
                    field.state.value = value;
                    field.validationErrors = validateElement(field);
                }
            },
            setPostnummerFieldValue(state, {fieldId, value}) {
                const field = state.postnummer[fieldId];
                if (field) {
                    field.state.value = value;
                    field.validationErrors = validateElement(field);
                }
            },
            setPickPostFieldValue(state, {fieldId, value}) {
                const field = state.pickPost[fieldId];
                if (field) {
                    field.state.value = value;
                    field.validationErrors = validateElement(field);
                }
            },
            validatePickupPerson(state) {
                const method = state.deliveryMethods.find((method) => method.selected);
                if ((method && method.id !== 'pickupPoint') ||
                    !state.pickupPerson.isSomeoneElse.state.value
                ) {
                    return;
                }

                state.pickupPerson.firstName.validationErrors = validateElement(state.pickupPerson.firstName);
                state.pickupPerson.lastName.validationErrors = validateElement(state.pickupPerson.lastName);
            },
            validatePostnummer(state) {
                if (state.postnummer) {
                    state.postnummer.postnummerValue.validationErrors = validateElement(state.postnummer.postnummerValue);
                }
            },
            validatePickPost(state) {
                if (state.pickPost) {
                    state.pickPost.pickPostValue.validationErrors = validateElement(state.pickPost.pickPostValue);
                }
            },
            setShowEditModeError(state, value) {
                state.showEditModeError = value;
            }
        }
    };
};

// TODO: Move function
function getLatLong(postalCode) {
    const country = require('../../../../../modules/util/getCountryFromLocaleCookie')();

    const coordinates = {
        latitude: null,
        longitude: null
    };

    return new Promise(function (resolve) {
        new google.maps.Geocoder().geocode({
            componentRestrictions: {
                country
            },
            address: postalCode.replace(' ', '+') + ',+' + country,
            region: country
        }, function (results, status) {
            if (status !== 'OK') {
                resolve(coordinates);
                return;
            }

            const location = results[0].geometry.location;
            coordinates.latitude = location.lat();
            coordinates.longitude = location.lng();

            resolve(coordinates);
        });
    });
}
